import * as React from 'react';

import classnames from 'classnames';

import {Stack} from '../layout/stack/stack';

import {SecondaryValue} from './secondary-value';
import type {SecondaryValueType} from './secondary-value';

import styles from './metrics.module.css';

type Props = {
    size: 'small' | 'normal' | 'big';
    value: React.ReactNode;
    secondaryValue?: SecondaryValueType;
    bottomRow?: React.ReactNode;
    isCentered?: boolean;
    isBold?: boolean;
    valueIcon?: React.ReactNode; // Displays to the left of the value, ex user avatar
};

export function Stat(props: Props) {
    const styleNames = classnames({
        [styles['stat-value--small']]: props.size === 'small',
        [styles['stat-value--normal']]: props.size === 'normal',
        [styles['stat-value--bold']]: props.isBold,
        [styles['stat-value']]: props.size === 'big',
    });

    const valueIconStyleNames = classnames({
        [styles['value-icon--small']]: props.size === 'small',
        [styles['value-icon--normal']]: props.size === 'normal',
        [styles['value-icon']]: props.size === 'big',
    });

    return (
        <Stack alignItems={props.isCentered ? 'center' : undefined}>
            <Stack isHorizontal={true} spacing={props.valueIcon ? 8 : 0} alignItems='center'>
                <div className={valueIconStyleNames}>{props.valueIcon}</div>
                <div className={styleNames}>{props.value}</div>
            </Stack>
            {props.secondaryValue && <SecondaryValue secondaryValue={props.secondaryValue} />}
            {props.bottomRow}
        </Stack>
    );
}
